module.exports = __webpack_public_path__ + "static/media/billingActive.8af516f9.svg";